import { useContext } from 'react';
import { DiefCfemContext } from '../contexts/DiefCfemContext';
import { MessageStatus } from '@govbr-ds/react-components/dist/types/messages';
import { IErrorWithSentryId } from 'interfaces/IErrorWithSentryId';
import { incluirSentryIdMsgErro } from 'utils/incluirSentryIdMsgErro';

export const useNotificacao = () => {
  const context = useContext(DiefCfemContext);
  if (!context) {
    throw new Error('useNotificacao deve ser usado dentro de um DiefCfemProvider');
  }

  return ({
    conteudo,
    tipo,
    complementoSentryId,
  }: {
    conteudo: string;
    tipo: MessageStatus;
    complementoSentryId?: IErrorWithSentryId | null | undefined;
  }) => {
    context.setMensagens([
      ...context.mensagens,
      {
        tipo: tipo,
        mensagem: conteudo + (complementoSentryId ? ` ${incluirSentryIdMsgErro(complementoSentryId)}` : ''),
      },
    ]);
  };
};
